import { ApplicationState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import AppointmentForm  from "../components/Forms/AppointmentForm";
import { AppointmentEntity, ProfessionalEntity, ClientEntity } from "../store/entities/state";
import { isSubmittingNew, getEntitiesDataItems, getChangingValue, getChangingState, getPacksForProfessional, getPacksForClient } from "../store/entities/selectors";
import { createManyAppointments, createEntity, entityCreatingCancel, loadEntities, updateChangingEntity } from "../store/entities/actions";
import { createAppointmentAsync, createAppointmentsAsync, createClientAsync, getAppointmentAsync, getClientPacksAsync, getProfessionalPacksAsync } from "../ajax/requests";
import { AppointmentFormDispatchProps, AppointmentFormStateProps } from "../components/Forms/AppointmentForm/AppointmentForm";
import { canEditAppointments, canEditClients, canSeePrices, getMyUser, getPermissions } from "../store/session/selectors";
import { AppointmentChangeReason, ClientData, PermissionEnum } from "../models";
import { Guid } from "../shared/utils";
 
const mapStateToProps = (state: ApplicationState): AppointmentFormStateProps => {
    const data = getChangingValue(state, 'appointments') as AppointmentEntity
    return {
        type: 'create',
        data,
        hasChanged: getChangingState(state, 'appointments'),
        userProfessionalId: getMyUser(state)?.professionalId,
        clientPacks: data?.clientId ? getPacksForClient(data.clientId)(state) : undefined,
        professionalPacks: data?.professionalId ? getPacksForProfessional(data.professionalId)(state) : undefined,
        canManageAppointments: canEditAppointments(state),
        canManageClients: canEditClients(state),
        canSeePrices: canSeePrices(state),
        canEditPayments: canSeePrices(state),
        canDeletePayments: true,
        isSubmitting: isSubmittingNew(state, 'appointments'),
        clients: getEntitiesDataItems<ClientEntity>('clients')(state),
        professionals: getEntitiesDataItems<ProfessionalEntity>('professionals')(state),
    }
}

const mapDispatchToProps = (dispatch: AppThunkDispatch): AppointmentFormDispatchProps => ({
    onChange: (data: AppointmentEntity) => dispatch(updateChangingEntity('appointments', data)),
    onCancel: () => dispatch(entityCreatingCancel('appointments')),
    onSave: (data: AppointmentEntity, _: AppointmentChangeReason | undefined, ignoreAvailability: boolean) => 
        dispatch(createEntity('appointments', data, (c, state) => createAppointmentAsync(c, ignoreAvailability, !getPermissions(state).includes(PermissionEnum.DoNotAllowSkipAvailability))))
            .then(async (id) => {
                if (id) {
                    // Fetch the freshly created appointment to get server-calculated fields (price, payments, pack info)
                    await dispatch(loadEntities('appointments', () => getAppointmentAsync(id), 'AppendResult', [id]));
                }
                return id;
            }),
    onCreateMany: (data: AppointmentEntity[], ignoreAvailability) => 
        dispatch(createManyAppointments(data, c => createAppointmentsAsync(c, ignoreAvailability))),
    onCreateNewClient: (clientName: string, professionalId?: string) => {
        const client: ClientData = {id: Guid.newGuid(), name: clientName, professionalId}
        return dispatch(createEntity('clients', client, c => createClientAsync(c)))
    },
    onLoadClientPacks: (clientId: string) => {
        dispatch(loadEntities('clientPacks', () => getClientPacksAsync(clientId), 'AppendResult'))
    },
    onLoadProfessionalPacks: (professionalId: string) => {
        dispatch(loadEntities('clientPacks', () => getProfessionalPacksAsync(professionalId), 'AppendResult'))
    },
});

const AppointmentCreateForm = connect<AppointmentFormStateProps, AppointmentFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(AppointmentForm as any);

export default AppointmentCreateForm;
